const strings = {
  zh: {
    actCode: 'AppleEducationDiscount2019',
    loopPrizeCount: 30,
    actId: 543,
  }
};

export default function(name) {
  return strings['zh'][name];
}



// WEBPACK FOOTER //
// ./src/string/index.js